import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

const AddRecipeFormPanel = ({ open, onClose, onSubmit, categories = [], error = "" }) => {
  const [form, setForm] = useState({
    image: "",
    name: "",
    category: "",
    language: "English",
    htmlContent: "",
  });
  const [show, setShow] = useState(open);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShow(true);
      setTimeout(() => setIsVisible(true), 10);
      document.body.style.overflow = 'hidden';
    } else if (show) {
      setIsVisible(false);
      setTimeout(() => setShow(false), 500);
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!show) return null;

  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setForm({
      image: "",
      name: "",
      category: "",
      language: "English",
      htmlContent: "",
    });
  };

  const getLocalizedCategories = () => {
    const categoryMap = {
      'Breakfasts & Snacks': { English: 'Breakfasts & Snacks', Spanish: 'Desayunos y Meriendas' },
      'Lunches & Dinners': { English: 'Lunches & Dinners', Spanish: 'Comidas y Cenas' },
      'Desserts & Sweets': { English: 'Desserts & Sweets', Spanish: 'Postres y Dulces' },
      'Soups & Stews': { English: 'Soups & Stews', Spanish: 'Sopas, Guisos y Caldos' },
    };
    return categories.map(cat => categoryMap[cat]?.[form.language] || cat);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form, resetForm);
  };

  return (
    <div className="fixed inset-0 z-50 flex transition-all duration-500">
      <div className="flex-1 " onClick={onClose} />
      <div
        className={`w-full max-w-md bg-white h-full shadow-2xl p-6 sm:p-8 overflow-y-auto relative rounded-l-3xl border-l-2 border-orange
        transition-all duration-500 ease-in-out
        ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`}
      >
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-orange text-xl"
          onClick={onClose}
        >
          <FaTimes />
        </button>
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Add New Recipe</h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Image Link (URL)</label>
            <input
              name="image"
              value={form.image}
              onChange={handleFormChange}
              placeholder="https://example.com/image.jpg"
              className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2"
              required
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Recipe Title</label>
            <input
              name="name"
              value={form.name}
              onChange={handleFormChange}
              placeholder="e.g. Turmeric Cauliflower Tabbouleh"
              className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2"
              required
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Language</label>
            <select
              name="language"
              value={form.language}
              onChange={handleFormChange}
              className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2 bg-white text-gray-700 font-semibold appearance-none transition-all duration-150 shadow-sm hover:border-orange2 focus:outline-none"
              required
            >
              <option value="English">English</option>
              <option value="Spanish">Spanish</option>
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Category</label>
            <select
              name="category"
              value={form.category}
              onChange={handleFormChange}
              className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2 bg-white text-gray-700 font-semibold appearance-none transition-all duration-150 shadow-sm hover:border-orange2 focus:outline-none"
              required
            >
              <option value="" disabled>
                Choose Category
              </option>
              {categories.map((cat, index) => (
                <option key={cat} value={cat}>
                  {getLocalizedCategories()[index]}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Recipe HTML Content</label>
            <textarea
              name="htmlContent"
              value={form.htmlContent}
              onChange={handleFormChange}
              placeholder="Paste the HTML content here..."
              className="px-3 py-2 border border-orange rounded-md focus:ring-2 focus:ring-orange2 font-mono text-xs"
              rows={15}
              required
            />
          </div>
          {error && (
            <div className="text-red-600 text-sm font-medium">{error}</div>
          )}
          <button
            type="submit"
            className="mt-2 py-2 rounded-xl bg-orange2 text-white font-bold hover:bg-orange transition"
          >
            Add Recipe
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddRecipeFormPanel; 